import { useTranslation } from 'react-i18next'
import { useGenerateInvite } from './useGenerateInvite'

interface Props {
  isPlanner: boolean
}

export function InviteSection({ isPlanner }: Props) {
  const { t } = useTranslation()
  const generateInvite = useGenerateInvite()

  if (!isPlanner) return null

  const hoursUntilExpiry = generateInvite.data
    ? Math.ceil(
        (new Date(generateInvite.data.expiresAt).getTime() - Date.now()) / (1000 * 60 * 60),
      )
    : 48

  const handleCopy = () => {
    if (generateInvite.data) {
      navigator.clipboard.writeText(generateInvite.data.code)
    }
  }

  return (
    <section aria-label={t('household.invite.codeLabel')}>
      <h2 className="text-xl font-semibold text-ink mb-4">{t('household.invite.codeLabel')}</h2>

      <button
        onClick={() => generateInvite.mutate()}
        disabled={generateInvite.isPending}
        className="rounded-lg border border-accent text-accent font-semibold py-2.5 px-5 hover:bg-accent-tint focus:outline-none focus:ring-2 focus:ring-accent transition disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {t('household.invite.generateButton')}
      </button>

      {generateInvite.data && (
        <div className="mt-4 bg-surface rounded-xl border border-line p-5 space-y-3">
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted">{t('household.invite.codeLabel')}:</span>
            <strong className="font-mono text-lg tracking-widest text-ink">
              {generateInvite.data.code}
            </strong>
            <button
              onClick={handleCopy}
              className="ml-auto text-xs font-medium text-accent hover:text-accent-dark transition"
            >
              {t('household.invite.copyButton')}
            </button>
          </div>
          <p className="text-sm text-muted break-all">
            <span className="font-medium">{t('household.invite.linkLabel')}: </span>
            {generateInvite.data.inviteLink}
          </p>
          <p className="text-xs text-faint">
            {t('household.invite.expiresIn', { hours: hoursUntilExpiry })}
          </p>
        </div>
      )}
    </section>
  )
}
